<template>
  <div id="lines"></div>
</template>

<script>
export default {
  name: "ChartLines",
  props: ["templeDate"],
  data() {
    return { areaTimeData: {} };
  },
  watch: {
    templeDate: {
      deep: true,
      handler(newVal, oldVal) {
        this.areaTimeData = this.common.areaTimeCale(newVal);
        this.getAreaTimeLine();
      },
    },
  },

  computed: {
    // countries() {
    //   return [
    //     this.$t("chart.asia"),
    //     this.$t("chart.northAmerica"),
    //     this.$t("chart.southAmerica"),
    //     this.$t("chart.oceania"),
    //     this.$t("chart.europe"),
    //     this.$t("chart.africa"),
    //     this.$t("chart.antarctica"),
    //   ];
    // },
  },
  created() {},
  mounted() {},
  methods: {
    // 七大洲时间分布
    getAreaTimeLine() {
      let that = this;
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById("lines"));
      const countries = [
        this.$t("chart.asia"),
        this.$t("chart.northAmerica"),
        this.$t("chart.southAmerica"),
        this.$t("chart.oceania"),
        this.$t("chart.europe"),
        this.$t("chart.africa"),
        this.$t("chart.antarctica"),
      ];
      const datasetWithFilters = [];
      const seriesList = [];
      this.$echarts.util.each(countries, function (country) {
        var datasetId = "dataset_" + country;
        datasetWithFilters.push({
          id: datasetId,
          fromDatasetId: "dataset_raw",
          transform: {
            type: "filter",
            config: {
              and: [
                {
                  dimension: "Year",
                  gte: 987,
                },
                {
                  dimension: "Country",
                  "=": country,
                },
              ],
            },
          },
        });
        seriesList.push({
          type: "line",
          datasetId: datasetId,
          showSymbol: false,
          name: country,
          endLabel: {
            show: true,
            formatter: function (params) {
              return params.value[1] + ": " + params.value[0];
            },
          },
          labelLayout: {
            moveOverlap: "shiftY",
          },
          emphasis: {
            focus: "series",
          },
          encode: {
            x: "Year",
            y: that.$t("chart.num"),
            label: ["Country", that.$t("chart.num")],
            itemName: "Year",
            tooltip: [that.$t("chart.num")],
          },
        });
      });
      let option = {
        dataset: [
          {
            id: "dataset_raw",
            source: that.areaTimeData,
          },
          ...datasetWithFilters,
        ],
        title: {
          // 七大洲妈祖庙随时间增长修建数量折线图
          text: that.$t("chart.t7"),
          // 不包含年代不详的庙宇数量
          subtext: that.$t("chart.t8"),
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "rgb(240, 80, 47)",
            },
          },
        },
        // toolbox: {
        //   //echart保存为图片
        //   show: true,
        //   feature: {
        //     mark: {
        //       show: true,
        //     },
        //     // restore: {
        //     //   show: true,
        //     // },
        //     saveAsImage: {
        //       show: true,
        //       pixelRatio: 1,
        //       title: "保存为图片",
        //       type: "png",
        //       lang: ["点击保存"],
        //     },
        //   },
        // },
        xAxis: {
          type: "category",
          nameLocation: "middle",
        },
        yAxis: {
          // name: "数量",
        },

        grid: {
          right: 140,
        },
        series: seriesList,
        animationDuration: 8000,
      };
      option && myChart.setOption(option);
      // 响应布局
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    },
  },
  beforeDestroy() {
    // this.chart.dispose()
  },
};
</script>

<style lang="scss" scoped>
.chart_card {
  border-radius: 0.5rem;
  height: 20rem;
  width: 100%;
  padding: 0.5rem;
}
</style>
